import { defineMessages } from 'react-intl'

const messages = defineMessages({
  uom: {
    id: 'new_shipment.uom',
    description: 'UOM',
    defaultMessage: 'Units',
  },
  shipmentInformation: {
    id: 'new_shipment.shipment_information',
    description: 'Shipment Information',
    defaultMessage: 'Shipment Information',
  },
  templateNotFound: {
    id: 'new_shipment.template_not_found',
    description: 'Template not found',
    defaultMessage: 'Tracking Number Template not found',
  },
  loads: {
    id: 'new_shipment.loads',
    description: 'Consignment Load',
    defaultMessage: 'Loads',
  },
  consignmentLoad: {
    id: 'new_shipment.consignment_load',
    description: 'Consignment Load',
    defaultMessage: 'Load',
  },
  summary: {
    id: 'new_shipment.summary',
    description: 'Summary',
    defaultMessage: 'Summary',
  },
  shipFromDeliverTo: {
    id: 'new_shipment.ship_from_deliver_to',
    description: 'Ship From / Deliver To',
    defaultMessage: 'Ship From / Deliver To',
  },
  saveAndClose: {
    id: 'new_shipment.saveAndClose',
    description: 'Save & Close',
    defaultMessage: 'Save & Close',
  },
  consignment: {
    id: 'new_shipment.consignment',
    description: 'Consignment',
    defaultMessage: 'Consignments',
  },
  consignments: {
    id: 'new_shipment.consignments',
    description: 'Consignments',
    defaultMessage: 'Consignment(s)',
  },
  loadItem: {
    id: 'new_shipment.load_item',
    description: 'Load Item',
    defaultMessage: 'Load #{idx}',
  },
  consignmentItem: {
    id: 'new_shipment.consignment_item',
    description: 'Consignment Item',
    defaultMessage: 'Consignment #{idx}',
  },
  consignmentReferenceNumber: {
    id: 'new_shipment.consignment_reference_number',
    description: 'Reference Number',
    defaultMessage: 'Reference Number',
  },
  consignmentTrackingNumber: {
    id: 'new_shipment.consignment_tracking_number',
    description: 'Consignment Tracking Number',
    defaultMessage: 'Tracking Number (auto-generated)',
  },
  systemGenerated: {
    id: 'new_shipment.system_generated',
    description: 'System Generated',
    defaultMessage: 'System Generated',
  },
  consignmentDescription: {
    id: 'new_shipment.consignment_description',
    description: 'Consignment Description',
    defaultMessage: 'Description',
  },
  currency: {
    id: 'new_shipment.currency',
    description: 'Currency',
    defaultMessage: 'Currency',
  },
  addConsignment: {
    id: 'new_shipment.add_consignment',
    description: 'Add Consignment',
    defaultMessage: 'Add Consignment',
  },
  customer: {
    id: 'new_shipment.customer',
    description: 'Customer',
    defaultMessage: 'Customer',
  },
  customerReferenceNumber: {
    id: 'new_shipment.customer_reference_number',
    description: 'Customer Reference Number',
    defaultMessage: 'Customer Reference Number',
  },
  shipmentNumber: {
    id: 'new_shipment.shipment_number',
    description: 'Shipment Number',
    defaultMessage: 'Shipment Number (auto-generated)',
  },
  deliverTo: {
    id: 'new_shipment.deliver_to',
    description: 'Deliver To',
    defaultMessage: 'Deliver To',
  },
  location: {
    id: 'new_shipment.location',
    description: 'Location',
    defaultMessage: 'Location',
  },
  deliveryDate: {
    id: 'new_shipment.delivery_date',
    description: 'Delivery Date & Time',
    defaultMessage: 'Delivery Date',
  },
  contact: {
    id: 'new_shipment.contact',
    description: 'Contact',
    defaultMessage: 'Contact',
  },
  noContactsAvailable: {
    id: 'new_shipment.no_contacts_available',
    description: 'No Available Contacts',
    defaultMessage: 'No Available Contacts',
  },
  specialInstructions: {
    id: 'new_shipment.specialInstructions',
    description: 'Special Instructions',
    defaultMessage: 'Special Instructions',
  },
  address: {
    id: 'new_shipment.selected_location',
    description: 'Address',
    defaultMessage: 'Address',
  },
  clearingRequired: {
    id: 'new_shipment.clearing_required',
    description: 'Clearing Required',
    defaultMessage: 'Clearing Required',
  },
  showContents: {
    id: 'new_shipment.show_package_contents',
    description: 'Show Contents',
    defaultMessage: 'Show Contents',
  },
  packageContent: {
    id: 'new_shipment.package_content',
    description: 'Contents',
    defaultMessage: '{loadType} Contents',
  },
  declaredValue: {
    id: 'new_shipment.declared_value',
    description: 'Declared Value',
    defaultMessage: 'Declared Value',
  },
  detailLevel: {
    id: 'new_shipment.detail_level',
    description: 'Detail Level',
    defaultMessage: 'Detail Level',
  },
  specifyContent: {
    id: 'new_shipment.specify_content',
    description: 'Specify Content',
    defaultMessage: 'Specify Contents',
  },
  specifiedContents: {
    id: 'new_shipment.specified_contents',
    description: 'Specified Contents',
    defaultMessage: 'Specified Contents',
  },
  contentDescription: {
    id: 'new_shipment.content_description',
    description: 'Content Description',
    defaultMessage: 'Content Description',
  },
  unitPrice: {
    id: 'new_shipment.unit_price',
    description: 'Unit Price',
    defaultMessage: 'Unit Price',
  },
  addProduct: {
    id: 'new_shipment.add_product',
    description: 'Add Product',
    defaultMessage: 'Add Product',
  },
  addItem: {
    id: 'new_shipment.add_item',
    description: 'Add Item',
    defaultMessage: 'Add Item',
  },
  removeProduct: {
    id: 'new_shipment.remove_product',
    description: 'Remove Product',
    defaultMessage: 'Remove',
  },
  customerInformation: {
    id: 'new_shipment.customer_information',
    description: 'Customer Information',
    defaultMessage: 'Customer Information',
  },
  consignmentInformation: {
    id: 'new_shipment.consignment_information',
    description: 'Consignment Information',
    defaultMessage: 'Consignment Information',
  },
  shipFrom: {
    id: 'new_shipment.ship_from',
    description: 'Ship From',
    defaultMessage: 'Ship From',
  },
  requestedDate: {
    id: 'new_shipment.requested_date',
    description: 'Requested Date',
    defaultMessage: 'Requested Date',
  },
  scheduledDateLabel: {
    id: 'new_shipment.scheduled_date_label',
    description: 'Scheduled Date Label',
    defaultMessage: 'Scheduled Date',
  },
  addLoad: {
    id: 'new_shipment.add_load',
    description: 'Add Load',
    defaultMessage: 'Add Load',
  },
  loadType: {
    id: 'new_shipment.load_type',
    description: 'Load Type',
    defaultMessage: 'Type',
  },
  consignmentType: {
    id: 'new_shipment.consignment_type',
    description: 'Consignment Type',
    defaultMessage: 'Type',
  },
  noOfIdenticalLoads: {
    id: 'new_shipment.no_of_identical_loads',
    description: 'Number of Identical Loads`',
    defaultMessage: 'No. of Identical {loadType}(s)',
  },
  dimensions: {
    id: 'new_shipment.dimensions',
    description: 'Dimensions',
    defaultMessage: 'Dimensions',
  },
  weight: {
    id: 'new_shipment.weight',
    description: 'Weight',
    defaultMessage: '{loadType} Gross Weight',
  },
  netWeight: {
    id: 'new_shipment.net_weight',
    description: 'Net Weight',
    defaultMessage: 'Net Weight',
  },
  packageWeight: {
    id: 'new_shipment.package_weight',
    description: 'Package Weight',
    defaultMessage: 'Package Weight',
  },
  grossWeight: {
    id: 'new_shipment.gross_weight',
    description: 'Gross Weight',
    defaultMessage: 'Gross Weight',
  },
  tareWeight: {
    id: 'new_shipment.tare_weight',
    description: 'Tare Weight',
    defaultMessage: 'Tare Weight',
  },
  tareWeightValidationError: {
    id: 'new_shipment.tare_weight_validation_error',
    description: 'Tare Weight Validation Error',
    defaultMessage: 'Tare Weight must equal Gross Weight minus Net Weight',
  },
  payloadWeight: {
    id: 'new_shipment.payload_weight',
    description: 'Payload Weight',
    defaultMessage: 'Payload Weight',
  },
  parcelWeight: {
    id: 'new_shipment.parcel_weight',
    description: 'Parcel Weight',
    defaultMessage: 'Parcel Weight',
  },
  crateWeight: {
    id: 'new_shipment.crate_weight',
    description: 'Crate Weight',
    defaultMessage: 'Crate Weight',
  },
  columnWeight: {
    id: 'new_shipment.column_weight',
    description: 'Weight',
    defaultMessage: 'Gross Weight',
  },
  length: {
    id: 'new_shipment.length',
    description: 'Length',
    defaultMessage: 'Length',
  },
  width: {
    id: 'new_shipment.width',
    description: 'Width',
    defaultMessage: 'Width',
  },
  height: {
    id: 'new_shipment.height',
    description: 'Height',
    defaultMessage: 'Height',
  },
  temperatureControlled: {
    id: 'new_shipment.temperature_controlled',
    description: 'Temperature Controlled',
    defaultMessage: 'Temperature Controlled',
  },
  temperatureRange: {
    id: 'new_shipment.temperature_range',
    description: 'Temperature Range',
    defaultMessage: 'Temperature Range',
  },
  products: {
    id: 'new_shipment.products',
    description: 'Products',
    defaultMessage: 'Products',
  },
  productDescription: {
    id: 'new_shipment.product_description',
    description: 'Product Description',
    defaultMessage: 'Product Description',
  },
  countryOfOrigin: {
    id: 'new_shipment.country_of_origin',
    description: 'Country of Origin',
    defaultMessage: 'Country of Origin',
  },
  quantity: {
    id: 'new_shipment.quantity',
    description: 'Quantity',
    defaultMessage: 'Quantity',
  },
  totalValue: {
    id: 'new_shipment.total_value',
    description: 'Total Value',
    defaultMessage: 'Total Value',
  },
  useProduct: {
    id: 'new_shipment.use_product',
    description: 'Use Product',
    defaultMessage: 'Use Product',
  },
  isHazardous: {
    id: 'new_shipment.isHazardous',
    description: 'Is Hazardous',
    defaultMessage:
      'The contents of this load contain elements of lithium or other flammable and hazardous material',
  },
  remove: {
    id: 'new_shipment.remove',
    description: 'Remove',
    defaultMessage: 'Remove',
  },
  containerType: {
    id: 'new_shipment.container_type',
    description: 'Container Type',
    defaultMessage: 'Container Type',
  },
  palletType: {
    id: 'new_shipment.pallet_type',
    description: 'Pallet Type',
    defaultMessage: 'Pallet Type',
  },
  temperatureSetPoint: {
    id: 'new_shipment.temperature_set_point',
    description: 'Temperature Set Point',
    defaultMessage: 'Set Point',
  },
  isStackable: {
    id: 'common.isStackable',
    defaultMessage: 'Is Stackable',
    description: 'The label for the is stackable',
  },
  product: {
    id: 'new_shipment.product',
    description: 'Product',
    defaultMessage: 'Product',
  },
  returnTo: {
    id: 'new_shipment.return_to',
    description: 'Return To',
    defaultMessage: 'Return To',
  },
  sameAsDefault: {
    id: 'new_shipment.same_as_default',
    description: 'Same as Default',
    defaultMessage: 'Same as Ship From',
  },
  different: {
    id: 'new_shipment.different',
    description: 'Different',
    defaultMessage: 'Different',
  },
  description: {
    id: 'common.description',
    defaultMessage: 'Description',
    description: 'The label for the description',
  },
  autoGenerated: {
    id: 'common.autoGenerated',
    defaultMessage: 'Auto Generated',
    description: 'The label for the auto generated',
  },
  shipper: {
    id: 'new_shipment.shipper',
    description: 'Shipper',
    defaultMessage: 'Shipper',
  },
  lowerWarning: {
    id: 'new_shipment.lower_warning',
    description: 'Lower Warning',
    defaultMessage: 'Lower Warning',
  },
  upperWarning: {
    id: 'new_shipment.upper_warning',
    description: 'Upper Warning',
    defaultMessage: 'Upper Warning',
  },
  lowerCritical: {
    id: 'new_shipment.lower_critical',
    description: 'Lower Critical',
    defaultMessage: 'Lower Critical',
  },
  upperCritical: {
    id: 'new_shipment.upper_critical',
    description: 'Upper Critical',
    defaultMessage: 'Upper Critical',
  },
  modeOfTransit: {
    id: 'new_shipment.mode_of_transit',
    description: 'Mode of Transit',
    defaultMessage: 'Preferred Mode of Transit',
  },
  noPreference: {
    id: 'new_shipment.no_preference',
    description: 'No Preference',
    defaultMessage: 'No Preferred Carrier',
  },
  preferredCarrier: {
    id: 'new_shipment.preferred_carrier',
    description: 'Preferred Carrier',
    defaultMessage: 'Preferred Carrier',
  },
  preBookedTransit: {
    id: 'new_shipment.pre_booked_transit',
    description: 'Pre-booked Transit',
    defaultMessage: 'Pre-booked Transit',
  },
  carrier: {
    id: 'new_shipment.carrier',
    description: 'Carrier',
    defaultMessage: 'Carrier',
  },
  transitIdentifier: {
    id: 'new_shipment.transit_identifier',
    description: 'Transit Identifier',
    defaultMessage: 'Transit Identifier',
  },
  enterCarrier: {
    id: 'new_shipment.enter_carrier',
    description: 'Please select carrier',
    defaultMessage: 'Please select',
  },
  enterTransitIdentifier: {
    id: 'new_shipment.enter_transit_identifier',
    description: 'Enter transit identifier',
    defaultMessage: 'Enter transit identifier',
  },
  crossBorder: {
    id: 'new_shipment.cross_border',
    description: 'Cross Border',
    defaultMessage: 'Cross Border',
  },
  fulfilmentRequired: {
    id: 'new_shipment.fulfilment_required',
    description: 'Fulfilment Required',
    defaultMessage: 'Fulfilment Required',
  },
  transitDetails: {
    id: 'new_shipment.transit_details',
    description: 'Transit Details',
    defaultMessage: 'Transit Details',
  },
  showTransitDetails: {
    id: 'new_shipment.show_transit_details',
    description: 'Show Transit Details',
    defaultMessage: 'Show Transit Details',
  },
  openPackageContent: {
    id: 'new_shipment.open_package_content',
    description: 'Open Package Content',
    defaultMessage: 'Show {loadType} Content',
  },
  addWaypoint: {
    id: 'new_shipment.add_waypoint',
    description: 'Add Waypoint',
    defaultMessage: 'Add Waypoint',
  },
  waypoint: {
    id: 'new_shipment.waypoint',
    description: 'Waypoint',
    defaultMessage: 'Waypoint',
  },
  serviceWaypoint: {
    id: 'new_shipment.service_waypoint',
    description: 'Service Waypoint',
    defaultMessage: 'Service Waypoint',
  },
  waypointIdx: {
    id: 'new_shipment.waypoint_idx',
    description: 'Waypoint Index',
    defaultMessage: 'Waypoint {idx}',
  },
  shipmentUpdated: {
    id: 'new_shipment.shipment_updated',
    description: 'Shipment updated',
    defaultMessage: 'Shipment Draft Saved',
  },
  shipmentCreated: {
    id: 'new_shipment.shipment_created',
    description: 'Shipment created',
    defaultMessage: 'Shipment Created',
  },
  shipmentSaved: {
    id: 'new_shipment.shipment_saved',
    description: 'Shipment saved',
    defaultMessage: 'Shipment Saved',
  },
  acceptShipment: {
    id: 'new_shipment.accept_shipment',
    description: 'Accept Shipment',
    defaultMessage: 'Accept',
  },
  submitShipment: {
    id: 'new_shipment.submit_shipment',
    description: 'Submit Shipment',
    defaultMessage: 'Submit',
  },
  validationErrorsPresent: {
    id: 'new_shipment.validation_errors_present',
    description: 'Validation errors present',
    defaultMessage: 'Please fix all validation errors before submitting the shipment.',
  },
  fixValidationErrors: {
    id: 'new_shipment.fix_validation_errors',
    description: 'Fix validation errors',
    defaultMessage: 'Please fix all validation errors before submitting',
  },
  validationErrorsBeforeAccept: {
    id: 'new_shipment.validation_errors_before_accept',
    description: 'Validation errors before accept',
    defaultMessage: 'Please fix all validation errors before accepting the shipment.',
  },
  validationErrorsBeforeSubmit: {
    id: 'new_shipment.validation_errors_before_submit',
    description: 'Validation errors before submit',
    defaultMessage: 'Please fix all validation errors before submitting the shipment.',
  },
  shipmentAcceptFailed: {
    id: 'new_shipment.shipment_accept_failed',
    description: 'Failed to accept shipment',
    defaultMessage: 'Failed to accept shipment',
  },
  shipmentSubmitted: {
    id: 'new_shipment.shipment_submitted',
    description: 'Shipment accepted',
    defaultMessage: 'Shipment Submitted',
  },
  shipmentAccepted: {
    id: 'new_shipment.shipment_accepted',
    description: 'Shipment accepted',
    defaultMessage: 'Shipment Accepted',
  },
  status: {
    id: 'new_shipment.status',
    description: 'Status',
    defaultMessage: 'Status',
  },
  lockForReview: {
    id: 'new_shipment.lock_for_review',
    description: 'Lock for Review',
    defaultMessage: 'Lock for Review',
  },
  underReview: {
    id: 'new_shipment.under_review',
    description: 'Under Review',
    defaultMessage: 'Under Review',
  },
  completed: {
    id: 'new_shipment.completed',
    description: 'Completed',
    defaultMessage: 'Completed',
  },
  abandoned: {
    id: 'new_shipment.abandoned',
    description: 'Abandoned',
    defaultMessage: 'Abandoned',
  },
  archived: {
    id: 'new_shipment.archived',
    description: 'Archived',
    defaultMessage: 'Archived',
  },
  acceptedStatus: {
    id: 'new_shipment.accepted_status',
    description: 'Accepted',
    defaultMessage: 'Accepted',
  },
  submittedStatus: {
    id: 'new_shipment.submitted_status',
    description: 'Submitted',
    defaultMessage: 'Submitted',
  },
  draftStatus: {
    id: 'new_shipment.draft_status',
    description: 'Draft',
    defaultMessage: 'Draft',
  },
  createdStatus: {
    id: 'new_shipment.created_status',
    description: 'Created',
    defaultMessage: 'Created',
  },
  newShipment: {
    id: 'new_shipment.new_shipment',
    description: 'New Shipment',
    defaultMessage: 'New Shipment',
  },
  shipments: {
    id: 'new_shipment.shipments',
    description: 'Shipments',
    defaultMessage: 'Shipments',
  },
  submittedDate: {
    id: 'new_shipment.submitted_date',
    description: 'Submitted Date',
    defaultMessage: 'Submitted Date',
  },
  acceptedDate: {
    id: 'new_shipment.accepted_date',
    description: 'Accepted Date',
    defaultMessage: 'Accepted Date',
  },
  shipmentUpdateSuccess: {
    id: 'new_shipment.shipmentUpdateSuccess',
    description: 'Shipment update success message',
    defaultMessage: 'Shipment updated successfully',
  },
  shipmentLockedForReview: {
    id: 'new_shipment.shipment_locked_for_review',
    description: 'Shipment locked for review',
    defaultMessage: 'Shipment Locked',
  },
  shipmentUpdateError: {
    id: 'new_shipment.shipmentUpdateError',
    description: 'Shipment update error message',
    defaultMessage: 'Failed to update shipment',
  },
  countdownTitle: {
    id: 'new_shipment.countdown_title',
    description: 'Countdown Title',
    defaultMessage: 'Locked for review for {value}',
  },
  backToShipmentstBtn: {
    id: 'new_shipment.back_to_shipments_btn',
    description: 'Back to Shipments',
    defaultMessage: 'Back to Shipments',
  },
  buttonReject: {
    id: 'new_shipment.button_reject',
    description: 'Reject',
    defaultMessage: 'Reject',
  },
  shipmentRejected: {
    id: 'new_shipment.shipment_rejected',
    description: 'Shipment Rejected',
    defaultMessage: 'Shipment Rejected',
  },
  shipmentRejectFailed: {
    id: 'new_shipment.shipment_reject_failed',
    description: 'Failed to reject shipment',
    defaultMessage: 'Failed to reject shipment',
  },
  withdrawBtn: {
    id: 'new_shipment.withdraw_btn',
    description: 'Withdraw',
    defaultMessage: 'Withdraw',
  },
  shipmentRecalled: {
    id: 'new_shipment.shipment_recalled',
    description: 'Shipment recalled',
    defaultMessage: 'Shipment Withdrawn',
  },
  shipmentRecallFailed: {
    id: 'new_shipment.shipment_recall_failed',
    description: 'Failed to recall shipment',
    defaultMessage: 'Failed to recall shipment',
  },
  shipmentSubmittedSuccess: {
    id: 'new_shipment.shipmentSubmittedSuccess',
    description: 'Shipment submitted success message',
    defaultMessage: 'Shipment submitted successfully',
  },
  shipmentSubmitFailed: {
    id: 'new_shipment.shipmentSubmitFailed',
    description: 'Shipment submit failed message',
    defaultMessage: 'Failed to submit shipment',
  },
  shipmentTrackingNumber: {
    id: 'new_shipment.shipment_tracking_number',
    description: 'Shipment Number',
    defaultMessage: 'Shipment Number',
  },
  cargoValue: {
    id: 'new_shipment.cargo_value',
    description: 'Cargo Value',
    defaultMessage: 'Cargo Value',
  },
  acceptShipments: {
    id: 'new_shipment.accept_shipments',
    description: 'Accept Shipments',
    defaultMessage: 'Accept Shipments',
  },
  shipmentSaveDraftFailed: {
    id: 'new_shipment.shipment_save_draft_failed',
    description: 'Shipment save draft failed',
    defaultMessage: 'Failed to save draft shipment',
  },
  shipmentCreateFailed: {
    id: 'new_shipment.shipment_create_failed',
    description: 'Shipment create failed',
    defaultMessage: 'Failed to create shipment',
  },
  shipmentSaveFailed: {
    id: 'new_shipment.shipment_save_failed',
    description: 'Shipment save failed',
    defaultMessage: 'Failed to save shipment',
  },
  unitLabel: {
    id: 'new_shipment.unit_name',
    description: 'Unit Name',
    defaultMessage: 'Units',
  },
  emptyContainerReturn: {
    id: 'new_shipment.empty_container_return',
    description: 'Empty Container Return',
    defaultMessage: 'Empty Container Return',
  },
  emptyContainerCollection: {
    id: 'new_shipment.empty_container_collection',
    description: 'Empty Container Collection',
    defaultMessage: 'Empty Container Collection',
  },
  useEmptyContainerCollection: {
    id: 'new_shipment.use_empty_container_collection',
    description: 'Use Empty Container Collection',
    defaultMessage: 'Collect Empty Container',
  },
  useEmptyContainerReturn: {
    id: 'new_shipment.use_empty_container_return',
    description: 'Use Empty Container Return',
    defaultMessage: 'Return Empty Container',
  },
  shipment: {
    id: 'new_shipment.shipment',
    description: 'Shipment',
    defaultMessage: 'Shipment(s)',
  },
  load: {
    id: 'new_shipment.load',
    description: 'Load',
    defaultMessage: 'Load(s)',
  },
  contents: {
    id: 'new_shipment.contents',
    description: 'Contents',
    defaultMessage: 'Load Contents',
  },
  clearSelection: {
    id: 'new_shipment.clear_selection',
    description: 'Clear Selection',
    defaultMessage: 'Clear Selection',
  },
  selectProduct: {
    id: 'new_shipment.select_product',
    description: 'Select Product',
    defaultMessage: 'Select Product',
  },
  submitAndAccept: {
    id: 'new_shipment.submit_and_accept',
    description: 'Submit and Accept',
    defaultMessage: 'Submit and Accept',
  },
  requestedPickupDate: {
    id: 'new_shipment.requested_pickup_date',
    description: 'Requested Pickup Date',
    defaultMessage: 'Requested Pickup Date',
  },
  requestedDeliveryDate: {
    id: 'new_shipment.requested_delivery_date',
    description: 'Requested Delivery Date',
    defaultMessage: 'Requested Delivery Date',
  },
  lastStatusChangeDate: {
    id: 'new_shipment.last_status_change_date',
    description: 'Last Status Change Date',
    defaultMessage: 'Last Status Change',
  },
  unlock: {
    id: 'new_shipment.unlock',
    description: 'Unlock',
    defaultMessage: 'Unlock',
  },
  noConsignment: {
    id: 'new_shipment.no_consignment',
    description: 'No Consignment',
    defaultMessage: 'At least one consignment is required',
  },
  noLoad: {
    id: 'new_shipment.no_load',
    description: 'No Load',
    defaultMessage: 'At least one load is required',
  },
  noLoadContent: {
    id: 'new_shipment.no_load_content',
    description: 'No Load Content',
    defaultMessage: 'Load Contents must be specified',
  },
  transportMode: {
    id: 'new_shipment.transport_mode',
    description: 'Transport Mode',
    defaultMessage: 'Transport Mode',
  },
  carrierPreference: {
    id: 'new_shipment.carrier_preference',
    description: 'Carrier Preference',
    defaultMessage: 'Carrier Preference',
  },
  noShipperAvailable: {
    id: 'new_shipment.no_shipper_available',
    description: 'No Shipper Available',
    defaultMessage: 'No Shipper Available',
  },
  noCustomersAvailable: {
    id: 'new_shipment.no_customers_available',
    description: 'No Customers Available',
    defaultMessage: 'No Customers Available',
  },
  consignmentServices: {
    id: 'new_shipment.consignmentServices',
    description: 'Consignment Services',
    defaultMessage: 'Services',
  },
  selectService: {
    id: 'new_shipment.selectService',
    description: 'Select a service',
    defaultMessage: 'Select a service',
  },
  selectServicesForLoads: {
    id: 'new_shipment.selectServicesForLoads',
    description: 'Select Services for Each Load',
    defaultMessage: 'Select Services for Each Load',
  },
  selectServicesDescription: {
    id: 'new_shipment.selectServicesDescription',
    description: 'Select Services Description',
    defaultMessage:
      'Please select appropriate services for each consignment load at the waypoints below.',
  },
  noConsignmentsFound: {
    id: 'new_shipment.noConsignmentsFound',
    description: 'No consignments found',
    defaultMessage: 'No consignments found. Please add consignments in Step 1.',
  },
  reference: {
    id: 'new_shipment.reference',
    description: 'Reference',
    defaultMessage: 'Reference',
  },
  loadingServices: {
    id: 'new_shipment.loadingServices',
    description: 'Loading Services',
    defaultMessage: 'Loading available services...',
  },
  noServicesAvailable: {
    id: 'new_shipment.noServicesAvailable',
    description: 'No Services Available',
    defaultMessage: 'No services available for this load type',
  },
  services: {
    id: 'new_shipment.services',
    description: 'Services',
    defaultMessage: 'Services',
  },
  selectServices: {
    id: 'new_shipment.selectServices',
    description: 'Select Services',
    defaultMessage: 'Please select appropriate services',
  },
  locationName: {
    id: 'new_shipment.locationName',
    description: 'Location Name',
    defaultMessage: 'Location Name',
  },
  waypointType: {
    id: 'new_shipment.waypointType',
    description: 'Waypoint Type',
    defaultMessage: 'Waypoint Type',
  },
  service: {
    id: 'new_shipment.service',
    description: 'Service',
    defaultMessage: 'Service',
  },
  code: {
    id: 'new_shipment.code',
    description: 'Code',
    defaultMessage: 'Code',
  },
  emptyContainerRequest: {
    id: 'new_shipment..emptyContainerRequest',
    description: 'Empty Container Request',
    defaultMessage: 'Request',
  },
  addRequest: {
    id: 'new_shipment..addRequest',
    description: 'Add Request',
    defaultMessage: 'Add Request',
  },
  noPreferredShippingLine: {
    id: 'new_shipment.no_preferred_shipping_line',
    description: 'No Preferred Shipping Line',
    defaultMessage: 'No Preferred Shipping Line',
  },
  preferredShippingLine: {
    id: 'new_shipment.preferred_shipping_line',
    description: 'Preferred Shipping Line',
    defaultMessage: 'Preferred Shipping Line',
  },
  preBookedContainerReleaseOrder: {
    id: 'new_shipment.pre_booked_container_release_order',
    description: 'Pre-booked Container Release Order',
    defaultMessage: 'Pre-booked Container Release Order (CRO)',
  },
  shippingLine: {
    id: 'new_shipment.shipping_line',
    description: 'Shipping Line',
    defaultMessage: 'Shipping Line',
  },
  croNumber: {
    id: 'new_shipment.cro_number',
    description: 'CRO Number',
    defaultMessage: 'CRO Number',
  },
  validFrom: {
    id: 'new_shipment.valid_from',
    description: 'Valid From',
    defaultMessage: 'Valid From',
  },
  validTo: {
    id: 'new_shipment.valid_to',
    description: 'Valid To',
    defaultMessage: 'Valid To',
  },
  emptyCollectionTerminal: {
    id: 'new_shipment.empty_collection_terminal',
    description: 'Empty Collection Terminal',
    defaultMessage: 'Empty Collection Terminal',
  },
  consignmentTypeCannotBeChangedTenant: {
    id: 'new_shipment.consignment_type_cannot_be_changed_tenant',
    description: 'Consignment Type cannot be changed once saved.',
    defaultMessage: 'Once saved, Consignment Type, Customer and Currency cannot be changed.',
  },
  consignmentTypeCannotBeChangedCustomer: {
    id: 'new_shipment.consignment_type_cannot_be_changed',
    description: 'Consignment Type cannot be changed once saved.',
    defaultMessage: 'Once saved, Consignment Type and Currency cannot be changed.',
  },
  trackingNumbersGenerated: {
    id: 'new_shipment.tracking_numbers_generated',
    description: 'Tracking numbers generated',
    defaultMessage:
      'Once created, tracking number(s) will be generated for consignment(s). After this step, you will be unable to add or remove Consignments, Waypoints and/or Loads.',
  },
  shipmentAbandoned: {
    id: 'new_shipment.shipment_abandoned',
    description: 'Shipment Abandoned',
    defaultMessage: 'Shipment Abandoned',
  },
  shipmentNew: {
    id: 'new_shipment.shipment_new',
    description: 'New Shipment',
    defaultMessage: 'New',
  },
  confirmToggleModeTitle: {
    id: 'new_shipment.confirm_toggle_mode_title',
    description: 'Confirm toggle mode title',
    defaultMessage: 'Change Mode',
  },
  confirmToggleModeMessage: {
    id: 'new_shipment.confirm_toggle_mode_message',
    description: 'Confirm toggle mode message',
    defaultMessage:
      'You will lose all your changes below if you change mode. Are you sure you wish to continue?',
  },
  confirmToggleModeYes: {
    id: 'new_shipment.confirm_toggle_mode_yes',
    description: 'Confirm toggle mode yes button',
    defaultMessage: 'Yes',
  },
  confirmToggleModeNo: {
    id: 'new_shipment.confirm_toggle_mode_no',
    description: 'Confirm toggle mode no button',
    defaultMessage: 'No',
  },
  changeConsignmentTypeTitle: {
    id: 'new_shipment.change_consignment_type_title',
    description: 'Change consignment type confirmation title',
    defaultMessage: 'Change Consignment Type',
  },
  changeConsignmentTypeMessage: {
    id: 'new_shipment.change_consignment_type_message',
    description: 'Change consignment type confirmation message',
    defaultMessage:
      'Changing the Consignment Type of a copied Consignment will remove associated load(s). Are you sure you want to change the Consignment Type?',
  },
  yes: {
    id: 'new_shipment.yes',
    description: 'Yes button',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'new_shipment.no',
    description: 'No button',
    defaultMessage: 'No',
  },
  copyShipment: {
    id: 'new_shipment.copy_shipment',
    description: 'Copy Shipment',
    defaultMessage: 'Copy',
  },
  copyShipmentConfirmTitle: {
    id: 'new_shipment.copy_shipment_confirm_title',
    description: 'Copy Shipment Confirmation Title',
    defaultMessage: 'Copy Shipment',
  },
  copyShipmentConfirmMessage: {
    id: 'new_shipment.copy_shipment_confirm_message',
    description: 'Copy Shipment Confirmation Message',
    defaultMessage: 'Are you sure you want to copy this shipment?',
  },
  copyShipmentSuccess: {
    id: 'new_shipment.copy_shipment_success',
    description: 'Copy Shipment Success Message',
    defaultMessage: 'Shipment Copied Successfully.',
  },
  copyShipmentFailure: {
    id: 'new_shipment.copy_shipment_failure',
    description: 'Copy Shipment Failure Message',
    defaultMessage: 'Failed to copy shipment. Please try again.',
  },
  includeUnsubmitted: {
    id: 'new_shipment.include_unsubmitted',
    description: 'Include Unsubmitted toggle label',
    defaultMessage: 'Include Unsubmitted',
  },
  includeUnsubmittedRejected: {
    id: 'new_shipment.include_unsubmitted_rejected',
    description: 'Include Unsubmitted & Rejected toggle label',
    defaultMessage: 'Include Unsubmitted & Rejected',
  },
  includeAbandoned: {
    id: 'new_shipment.include_abandoned',
    description: 'Include Abandoned toggle label',
    defaultMessage: 'Include Abandoned',
  },
  includeCompletedArchived: {
    id: 'new_shipment.include_completed_archived',
    description: 'Include Completed & Archived toggle label',
    defaultMessage: 'Include Completed & Archived',
  },
  bannedCharactersWarning: {
    id: 'new_shipment.banned_characters_warning',
    description: 'Warning shown when user types a banned character',
    defaultMessage: 'Special characters such as < > {{ }} are not allowed',
  },
})

export default messages
